export const GET_AUDIT_LOGS = gql`
    query auditLogs {
        auditLogs {
            id
            ipAddress
            event
            userId
            details
            entity
            entityId
            user {
                firstName
                lastName
                role {
                    name
                    id
                    hierarchyLevel
                }
            }
            createdAt
        }
    }
`;
